import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CalendarLeistungListePage } from './calendar-leistung-liste';

@NgModule({
  declarations: [
    CalendarLeistungListePage,
  ],
  imports: [
    IonicPageModule.forChild(CalendarLeistungListePage),
  ],
})
export class CalendarLeistungListePageModule {}



// WEBPACK FOOTER //
// ./src/pages/calendar-leistung-liste/calendar-leistung-liste.module.ts